import { CaseGranulometry } from '../../CaseGranulometry';
import { getCaseGroundLevel } from '../levels/getCaseGroundLevel';

export const getCaseGroundLevelGeometryArea = (
  caseGranulometry: CaseGranulometry
): number | undefined => getCaseGroundLevel(caseGranulometry).geometry?.properties?.area;
